import React from 'react';

import { SelectionSet } from '../../../types/SelectionSet';
import Select, { ValueType } from 'react-select';

import { OptionsType } from '../../../types/OptionsType';
import { OnChange } from '../../../types/OnChange';

type Props = {
  onChange: OnChange;
  selectionSets: Array<SelectionSet>;
  selectionSet?: ValueType<OptionsType, false>;
  loading: boolean;
};

const SelectionSetSelector: React.FC<Props> = ({
  onChange,
  selectionSets,
  selectionSet,
  loading,
}: Props) => {
  const styles = {
    control: (base: any) => ({
      ...base,
      fontSize: '80%',
      minHeight: null,
    }),
    menu: (base: any) => ({
      ...base,
      fontSize: '80%',
    }),
    indicatorsContainer: (base: any) => ({
      ...base,
      padding: 0,
      fontSize: '50%',
    }),
  };

  return (
    <Select
      options={selectionSets.map(({ id, name }) => ({ value: id, label: name }))}
      onChange={onChange}
      isLoading={loading}
      isClearable={true}
      value={selectionSet}
      styles={styles}
      autoFocus={true}
    />
  );
};

export default SelectionSetSelector;
